
'use strict';

var mapAPI = require('../components/googleMapsLocation');
var toastMessageHelper = require('../utils/toastMessageHelper');

var invitedContacts = [];
var initialStepLabel = $('.find-registry').text();

/**
 * Cleans a string value by removing commas and trimming whitespace.
 * @param {string} value - The value to clean.
 * @returns {string} Cleaned value.
 */
function cleanValue(value) {
    return value ? String(value).replace(/,/g, '').trim() : '';
}

/**
 * Resolves the selected title code from hidden input, selected option, or dropdown default.
 * @param {string} inputSelector - Hidden input selector.
 * @param {string} [dropdownSelector] - Dropdown section selector.
 * @returns {string} Selected title code.
 */
function getSelectedTitleCode(inputSelector, dropdownSelector) {
    var $input = $(inputSelector);
    var inputValue = $input.val();

    if (inputValue) {
        return inputValue;
    }

    var $dropdown = dropdownSelector ? $(dropdownSelector) : $input.closest('.registry-title-dropdown');
    var selectedCode = $dropdown.find('.title-code-option.selected').attr('data-code');

    if (selectedCode) {
        return selectedCode;
    }

    return $dropdown.attr('data-default-code') || '';
}

/**
 * Updates the UI for the invited list.
 */
function updateInvitedContactsUI() {
    var $container = $('#invitedListContainer');
    $container.empty();
    invitedContacts.forEach(function (contact, idx) {
        var html = `
            <div class="d-flex justify-content-between align-items-center border p-2 mb-1 rounded">
                <span style="overflow: auto; scrollbar-width: none;">${contact}</span>
                <button type="button" class="btn btn-sm btn-link text-dark remove-invite" data-index="${idx}">&times;</button>
            </div>
        `;
        $container.append(html);
    });
    $('#invitedList').val(JSON.stringify(invitedContacts));
}

$('body').on('click', '.mobile-create-registry', function () {
    if ($('#isAuthenticated').val() !== 'true') {
        var $wrap = $('.ckc-login-countrycode-drop-down');
        $wrap.find('.custom-option-value.active, .custom-option-value.selected').removeClass('active selected');
        var $defaultOption = $wrap.find('.custom-option-value[data-id="+91"]');
        $defaultOption.addClass('active selected');
        $wrap.find('.custom-drop-down-login .selected-value').text($defaultOption.data('id')).addClass('active');
        $('#loginInput').addClass('w-100 border-left border-1').removeClass('country-code-field');
        $('.country-select-wrap').addClass('d-none');
        $('#loginInput').addClass('w-100');
        $('.login-modal-missing-error, .login-modal-customer-exists-error, .login-modal-result, .login-mobile-country-miss-match-error, #register-form-modal, .ckc-password-register-content, .ckc-register-form-content').addClass('d-none');
        $('#ckc-login-modal').modal('show');
        return;
    }
    $('#ckc-wedding-registry').modal('show');
    $('#weddingRegistryForm').find('input[type="text"]').not('#eventDate').val('');
    $('#selectedOccasionDisplay').text('Select Occasion');
    $('#registryOccasionInput').val('');
    $('#weddingRegistryForm').find('.invalid-feedback, .invalid-error-message')
        .addClass('d-none');
    $('#weddingRegistryForm').removeClass('d-none');
    $('#weddingRegistryAddressForm, .registry-settings-section, .registry-occasion-wrapper').addClass('d-none');
    var today = new Date();
    var day = String(today.getDate()).padStart(2, '0');
    var month = String(today.getMonth() + 1).padStart(2, '0');
    var year = today.getFullYear();

    $('#eventDate').val(day + '/' + month + '/' + year);
});

$(window).on('resize load', function () {
    var $modal = $('#ckc-wedding-registry');
    if ($(window).width() >= 1024) {
        if ($modal.hasClass('show')) {
            $modal.modal('hide');
        }
        $modal.removeClass('modal fade').addClass('d-block');
    } else {
        $modal.addClass('modal fade').removeClass('d-block');
        $modal.on('hidden.bs.modal', function () {
            if ($('.delivery-status').find('.invalid-pincode').length > 0) {
                $('.delivery-status').empty();
            }
        });
    }
});

/**
 * Fills the address fields from the selected location JSON.
 */
function fillAddressFields() {
    try {
        var locationVal = $('#selectedLocation').val();
        if (locationVal) {
            var location = JSON.parse(locationVal);
            if (location && typeof location === 'object') {
                $('.registry-address-one').val(cleanValue(location.address1));
                $('.registry-address-two').val(cleanValue(location.address2));
                $('.registry-address-pincode').val(cleanValue(location.pincode));
                $('.registry-address-city').val(cleanValue(location.city));
            }
        }
    } catch (error) {
        // silent
    }
}

/**
 * Opens the shared map modal and initializes Google Maps only on demand.
 */
function openLocateOnMapModal() {
    $('#locateOnMapModal').modal('show');

    mapAPI.initMap().then(function (map) {
        if (map && window.google && window.google.maps) {
            window.google.maps.event.trigger(map, 'resize');
        }
    }).catch(function () {
        // Leave modal state unchanged; geolocation flows handle their own errors.
    });
}

/**
 * Shows a validation error for the given input.
 * @param {JQuery} $input - The input element.
 * @param {string} message - The error message.
 */
function showError($input, message) {
    var $target = $input;
    if ($input.attr('type') === 'hidden') {
        var $dropdown = $input.closest('.custom-drop-down-section').find('.custom-drop-down');
        if ($dropdown.length) $target = $dropdown;
    }
    $target.addClass('is-invalid');
    var $errorDiv;
    if ($target.hasClass('custom-drop-down')) {
        $errorDiv = $target.parent().find('.invalid-feedback');
    } else {
        $errorDiv = $target.siblings('.invalid-feedback');
    }
    if ($errorDiv.length) {
        $errorDiv.removeClass('d-none');
        if (message) $errorDiv.text(message);
    }
}

/**
 * Clears validation error for the given input.
 * @param {JQuery} $input - The input element.
 */
function clearError($input) {
    var $target = $input;
    if ($input.attr('type') === 'hidden') {
        var $dropdown = $input.closest('.custom-drop-down-section').find('.custom-drop-down');
        if ($dropdown.length) $target = $dropdown;
    }
    $target.removeClass('is-invalid');
    $input.closest('.registry-title-input-group').find('.firstname-wrapper').removeClass('is-invalid');
    var $errorDiv;
    if ($target.hasClass('custom-drop-down')) {
        $errorDiv = $target.parent().find('.invalid-feedback');
    } else {
        $errorDiv = $target.siblings('.invalid-feedback');
    }
    if ($errorDiv.length) {
        $errorDiv.addClass('d-none');
    }
}
/**
 * Shows the given section and hides others in the registry flow.
 * @param {string} sectionClass - The selector for the section to show.
 */
function showSection(sectionClass) {
    $('#weddingRegistryForm, #weddingRegistryAddressForm, .registry-settings-section, .registry-occasion-wrapper').addClass('d-none');
    if (sectionClass === '.registry-settings-section') {
        $('.find-registry').text($('.find-registry').data('final-step-label'));
    } else {
        $('.find-registry').text(initialStepLabel);
    }
    $(sectionClass).removeClass('d-none');
}

/**
 * Validates a name field for required, no numbers, no double spaces, and allowed characters.
 * @param {JQuery} $input - The input element.
 * @param {string} errorIdMissing - The ID of the error message element to show when the field is missing.
 * @param {string} errorIdInvalid - The ID of the error message element to show when the field is invalid.
 * @returns {boolean} True if valid, false otherwise.
 */
function validateNameField($input, errorIdMissing, errorIdInvalid) {
    var val = $input.val();
    var $wrapper = $input.closest('.registry-title-input-group').find('.firstname-wrapper').first();
    var $validationTarget = $wrapper.length ? $wrapper : $input;

    if (!val || !val.trim()) {
        $('#' + errorIdMissing).removeClass('d-none');
        $validationTarget.addClass('is-invalid');
        return false;
    }
    if (/\d/.test(val) || /\s{2,}/.test(val) || !/^[a-zA-Z\s'-]+$/.test(val)) {
        if (errorIdInvalid) {
            $('#' + errorIdInvalid).removeClass('d-none');
        }
        $validationTarget.addClass('is-invalid');
        return false;
    }

    $validationTarget.removeClass('is-invalid');
    return true;
}

var selectedOccasion = null;
$('body').on('click', '.wedding-registry-details-button', function (e) {
    if ($('#isAuthenticated').val() !== 'true') {
        var $wrap = $('.ckc-login-countrycode-drop-down');
        $wrap.find('.custom-option-value.active, .custom-option-value.selected').removeClass('active selected');
        var $defaultOption = $wrap.find('.custom-option-value[data-id="+91"]');
        $defaultOption.addClass('active selected');
        $wrap.find('.custom-drop-down-login .selected-value').text($defaultOption.data('id')).addClass('active');
        $('#loginInput').addClass('w-100 border-left border-1').removeClass('country-code-field');
        $('.country-select-wrap').addClass('d-none');
        $('#loginInput').addClass('w-100');
        $('.login-modal-missing-error, .login-modal-customer-exists-error, .login-modal-result, .login-mobile-country-miss-match-error, #register-form-modal, .ckc-password-register-content, .ckc-register-form-content').addClass('d-none');
        $('#ckc-login-modal').modal('show');
        return;
    }
    var isValid = true;
    var $firstName = $('#registryFirstName');
    var $lastName = $('#registryLastName');
    var $occasion = $('#registryOccasionInput');
    var $eventDate = $('#eventDate');

    if (!validateNameField($firstName, 'msgErrorFirstNameMissing', 'msgErrorFirstNameInvalid')) isValid = false;
    if (!validateNameField($lastName, 'msgErrorLastNameMissing', 'msgErrorLastNameInvalid')) isValid = false;
    if (!$occasion.val().trim()) { showError($occasion, $('#msgErrorSelectOccasion').val()); isValid = false; }
    if (!$eventDate.val().trim()) { showError($eventDate, $('#msgErrorEnterEventDate').val()); isValid = false; }

    if (!isValid) {
        e.preventDefault();
        return;
    }

    selectedOccasion = $occasion.val().trim();
    if (selectedOccasion === 'wedding') {
        showSection('.registry-occasion-wrapper');
    } else {
        showSection('#weddingRegistryAddressForm');
    }
});

$('body').on('click', '.custom-option-value', function () {
    var selected = $(this).data('value') || '';
    var selectedValue = selected.toLowerCase();
    var parentDropdown = $(this).closest('.custom-drop-down-section');

    // Update hidden input and clear error
    var $hiddenInput = parentDropdown.find('input[type="hidden"]');
    if ($hiddenInput.length === 0) {
        // Fallback: try to find by ID if not found in parent
        $hiddenInput = $('#registryRelationshipInput');
    }
    $hiddenInput.val(selectedValue);
    clearError($hiddenInput);

    if (selectedValue === 'wedding') {
        selectedOccasion = selectedValue;
    } else if (parentDropdown.find('#registryOccasionInput').length > 0) {
        selectedOccasion = selectedValue;
    }

    if (parentDropdown.hasClass('registry-visibility')) {
        if (selectedValue === 'private') {
            $('#registryInviteSection').removeClass('d-none');
        } else {
            $('#registryInviteSection').addClass('d-none');
        }
    }
    // Update display text and hide dropdown
    parentDropdown.find('.selected-value').text($(this).text()).addClass('active');
    parentDropdown.find('.custom-option-values').hide();
});

// 1) Open file selector when clicking Choose File
$('body').on('click', '.choose-file-btn', function (e) {
    e.preventDefault();
    $(this).siblings('.uploadInput').click();
});

// 3) Remove uploaded file preview
$('body').on('click', '.remove-file', function () {
    $(this).closest('.uploaded-file').remove();
});

$('body').on('change', '.uploadInput', function () {
    var files = this.files;
    $('.registry-uploaded-files').removeClass('d-none');
    var previewContainer = $('.registry-uploaded-files');
    if (!files || files.length === 0) return;

    // get existing file names
    var fileNames = [];
    var existing = $('#uploadedFileNames').val();
    if (existing) {
        try { fileNames = JSON.parse(existing); } catch (e) { fileNames = []; }
    }

    for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
        let fileObject = files[fileIndex];
        fileNames.push(fileObject.name);

        let fileReader = new FileReader();
        fileReader.onload = function (event) {
            var html = `
                <div class="uploaded-file d-flex align-items-center justify-content-between border p-2 rounded mb-2">
                    <div class="d-flex align-items-center">
                        <img src="${event.target.result}" style="width:48px; height:auto; margin-right:10px;">
                        <div class="uploaded-file-details">
                            <div class="file-details d-flex">
                                <div class="file-name small">${fileObject.name}</div>
                                <div class="file-size small text-muted">${(fileObject.size / (1024 * 1024)).toFixed(2)} MB</div>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-link text-dark remove-file">&times;</button>
                </div>
            `;
            previewContainer.append(html);
        };
        fileReader.readAsDataURL(fileObject);
    }

    $('#uploadedFileNames').val(JSON.stringify(fileNames));
});

$('body').on('click', '.registry-address-next', function (e) {
    e.preventDefault();
    var isValid = true;
    var $visibleSection = $('.registry-step:not(.d-none)');
    $visibleSection.find('.registry-address-one').each(function () {
        if (!$(this).val().trim()) { showError($(this), $('#msgErrorEnterHouseFlat').val()); isValid = false; }
    });
    $visibleSection.find('.registry-address-two').each(function () {
        if (!$(this).val().trim()) { showError($(this), $('#msgErrorEnterApartmentRoadArea').val()); isValid = false; }
    });
    $visibleSection.find('.registry-address-pincode').each(function () {
        if (!$(this).val().trim()) { showError($(this), $('#msgErrorEnterPincode').val()); isValid = false; }
    });
    $visibleSection.find('.registry-address-city').each(function () {
        if (!$(this).val().trim()) { showError($(this), $('#msgErrorEnterCity').val()); isValid = false; }
    });

    if ($visibleSection.hasClass('registry-occasion-wrapper')) {
        var $bride = $('#brideName');
        var $groom = $('#groomName');
        var $family = $('#familyName');
        if (!validateNameField($bride, 'msgErrorBrideNameMissing', 'msgErrorBrideNameInvalid')) isValid = false;
        if (!validateNameField($groom, 'msgErrorGroomNameMissing', 'msgErrorGroomNameInvalid')) isValid = false;
        if (!validateNameField($family, 'msgErrorFamilyNameMissing', 'msgErrorFamilyNameInvalid')) isValid = false;
    }

    if (!isValid) {
        e.preventDefault();
        return;
    }

    e.preventDefault();
    var $button = $(this);
    var url = $button.data('create-url');

    $.ajax({
        url: url,
        method: 'POST',
        success: function (res) {
            if (res.success && res.registryId) {
                if ($('#registryId').length === 0) {
                    $('<input>').attr({
                        type: 'hidden',
                        id: 'registryId',
                        name: 'registryId',
                        value: res.registryId
                    }).appendTo('body');
                } else {
                    $('#registryId').val(res.registryId);
                }
                showSection('.registry-settings-section');
            }
        },
        error: function () {
            // Registry creation failed; error message available in #msgErrorCreateRegistry
        }
    });
});

$('body').on('click', '.registry-settings-back-button', function (e) {
    e.preventDefault();
    if (selectedOccasion === 'wedding') showSection('.registry-occasion-wrapper');
    else showSection('#weddingRegistryAddressForm');
});

$('body').on('click', '.registry-address-button', function (e) { e.preventDefault(); showSection('#weddingRegistryForm'); });
$('body').on('click', '.registry-settings-button', function (e) {
    e.preventDefault();
    if (selectedOccasion === 'wedding') showSection('.wedding-registry-form');
    else showSection('#weddingRegistryAddressForm');
});
$('body').on('click', '.registry-wedding-occation', function () { showSection('.registry-settings-section'); });

$('body').on('click', '.registry-settings-submit', function (e) {
    var isValid = true;
    var $visibility = $('#registryVisibilityInput');
    if (!$visibility.val().trim()) {
        showError($visibility, $('#msgErrorSelectVisibility').val());
        isValid = false;
    }
    if ($('#creatingForSomeoneElse').is(':checked')) {
        var $creatorName = $('#creatorName');
        var $relationship = $('#registryRelationshipInput');
        if (!validateNameField($creatorName, 'msgErrorCreatorNameMissing', 'msgErrorCreatorNameInvalid')) isValid = false;
        if (!$relationship.val().trim()) { showError($relationship, $('#msgErrorSelectRelationship').text()); isValid = false; }
    }
    if (!isValid) {
        e.preventDefault();
        return;
    }
    e.preventDefault();
    var formUrl = $(this).data('url');
    if (!formUrl) {
        return;
    }
    var formData = new FormData();
    formData.append('customerTitle', getSelectedTitleCode('#registryCustomerTitle'));
    formData.append('firstName', $('#registryFirstName').val());
    formData.append('lastName', $('#registryLastName').val());
    formData.append('occasion', selectedOccasion);
    formData.append('eventDate', $('#eventDate').val());
    if (selectedOccasion === 'wedding') {
        formData.append('brideCustomerTitle', getSelectedTitleCode('#brideCustomerTitle'));
        formData.append('groomCustomerTitle', getSelectedTitleCode('#groomCustomerTitle'));
        formData.append('brideName', $('#brideName').val());
        formData.append('groomName', $('#groomName').val());
        formData.append('familyName', $('#familyName').val());
    }
    var uploadedFileNames = JSON.parse($('#uploadedFileNames').val() || '[]');
    $('.uploadInput').each(function () {
        var files = this.files;
        if (files && files.length > 0) {
            for (var fileIndex = 0; fileIndex < files.length; fileIndex++) {
                formData.append('photo', files[fileIndex]);
            }
        }
    });
    formData.append('uploadedFileNames', JSON.stringify(uploadedFileNames));
    formData.append('houseFlat', $('.registry-address-one').val());
    formData.append('apartmentRoadArea', $('.registry-address-two').val());
    formData.append('pinCode', $('.registry-address-pincode').val());
    formData.append('city', $('.registry-address-city').val());
    formData.append('registryId', $('#registryId').val());
    formData.append('visibility', $('#registryVisibilityInput').val());
    formData.append('invitedList', $('#invitedList').val());
    formData.append('isForSomeoneElse', $('#creatingForSomeoneElse').is(':checked'));
    if ($('#creatingForSomeoneElse').is(':checked')) {
        var creatorNameVal = $('#creatorName').val() || '';
        var relationshipVal = $('#registryRelationshipInput').val() || '';
        formData.append('creatorName', creatorNameVal);
        formData.append('relationship', relationshipVal);
    }
    formData.append('invitees', JSON.stringify(invitedContacts));
    var url = $(this).data('url');
    $.ajax({
        url: url,
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: function (res) {
            if (res.success) {
                window.location.href = res.redirectUrl;
            }
        },
        error: function () {
            // Registry save failed; error message available in #msgErrorSaveRegistry
        }
    });
});

$('body').on('keydown', '.wedding-registry-form-date-input', function (e) {
    e.preventDefault();
});

$('body').on('click', '#btnAddInvite', function () {
    var $input = $('#inviteInput');
    var input = $input.val().trim();
    clearError($input);

    if (!input) {
        showError($input, $('#msgErrorEnterEmailOrPhone').val());
        return;
    }
    var isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input);
    if (!isEmail) {
        showError($input, $('#msgErrorInvalidEmailOrPhone').val());
        return;
    }
    if (invitedContacts.indexOf(input) !== -1) {
        toastMessageHelper.showNotification($('.inviteRegistryContactExist').val());
        return;
    }
    if (invitedContacts.length >= 50) {
        toastMessageHelper.showNotification($('.inviteRegistryLimitExceed').val());
        return;
    }
    invitedContacts.push(input);
    updateInvitedContactsUI();
    $input.val('');
});

$('body').on('click', '.remove-invite', function () {
    var index = $(this).data('index');
    invitedContacts.splice(index, 1);
    updateInvitedContactsUI();
});

$('body').on('click', '.wedding-registry-form-date-input', function (e) {
    e.preventDefault();

    var $dateInput = $(this);

    // Prevent re-initializing every click
    if ($dateInput.data('datepicker-initialized')) {
        $('.table-condensed .prev, .table-condensed .next').text('');
        return;
    }

    if (typeof $.fn.datepicker !== 'undefined') {
        $.fn.datepicker.dates.en.daysMin = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

        $dateInput
            .datepicker({
                format: 'dd/mm/yyyy',
                language: 'en',
                autoclose: true,
                todayHighlight: false,
                startDate: '+0d',
                weekStart: 1,
                maxViewMode: 2
            })
            .datepicker('setDate', new Date())
            .on('show', function (ev) {
                ev.stopPropagation();
            });

        // mark as initialized
        $dateInput.data('datepicker-initialized', true);

        // clear arrows text
        $('.table-condensed .prev, .table-condensed .next').text('');

        // open immediately on first click
        $dateInput.datepicker('show');
    }
});

$(document).ready(function () {
    // Restrict input for name fields (no numbers, no double spaces, no special chars)

    var nameFieldsSelector = '#registryFirstName, #registryLastName, #brideName, #groomName, #familyName, #creatorName';
    $('body').on('input', nameFieldsSelector, function () {
        var $this = $(this);
        var val = $this.val();
        var originalVal = val;
        val = val.replace(/\d/g, '');
        val = val.replace(/\s{2,}/g, ' ');
        val = val.replace(/[^a-zA-Z\s'-]/g, '');
        if (val !== originalVal) {
            $this.val(val);
        }
    });

    $('body').on('input change', '.form-control', function () {
        clearError($(this));
    });

    // Blur validation for Name fields
    $('body').on('blur', nameFieldsSelector, function () {
        var $this = $(this);
        var id = $this.attr('id');
        if (id === 'registryFirstName') validateNameField($this, 'msgErrorFirstNameMissing', 'msgErrorFirstNameInvalid');
        else if (id === 'registryLastName') validateNameField($this, 'msgErrorLastNameMissing', 'msgErrorLastNameInvalid');
        else if (id === 'brideName') validateNameField($this, 'msgErrorBrideNameMissing', 'msgErrorBrideNameInvalid');
        else if (id === 'groomName') validateNameField($this, 'msgErrorGroomNameMissing', 'msgErrorGroomNameInvalid');
        else if (id === 'familyName') validateNameField($this, 'msgErrorFamilyNameMissing', 'msgErrorFamilyNameInvalid');
        else if (id === 'creatorName') validateNameField($this, 'msgErrorCreatorNameMissing', 'msgErrorCreatorNameInvalid');
    });

    // Blur validation for Address fields

    $('body').on('blur', '.registry-address-one', function () {
        if (!$(this).val().trim()) showError($(this), $('#msgErrorEnterHouseFlat').val());
    });
    $('body').on('blur', '.registry-address-two', function () {
        if (!$(this).val().trim()) showError($(this), $('#msgErrorEnterApartmentRoadArea').val());
    });
    $('body').on('blur', '.registry-address-pincode', function () {
        if (!$(this).val().trim()) showError($(this), $('#msgErrorEnterPincode').val());
    });
    $('body').on('blur', '.registry-address-city', function () {
        if (!$(this).val().trim()) showError($(this), $('#msgErrorEnterCity').val());
    });

    // Blur validation for Event Date
    $('body').on('blur', '#eventDate', function () {
        if (!$(this).val().trim()) showError($(this), $('#msgErrorEnterEventDate').val());
    });

    // Map location handlers
    $('body').on('click', '#btnLocateOnMap', function (e) {
        e.preventDefault();
        openLocateOnMapModal();
    });
    $('body').on('click', '.btn-confirm-location', function () {
        mapAPI.updateLatLng($('#selectedLocation'));
        $('#locateOnMapModal').modal('hide');
        $('#tryAtHomeModal').modal('show');
        fillAddressFields();
    });
    $('body').on('click', '#btnCurrentLocation', function (e) {
        e.preventDefault();
        mapAPI.getCurrentLocationWithAddress()
            .then(function (result) {
                $('#selectedLocation').val(JSON.stringify(result.address));
                fillAddressFields();
            })
            .catch(function () {
                if (!$('.location-permission-error').hasClass('opened-once') && $('#tryAtHomeModal').hasClass('enabled')) {
                    $('.location-permission-error').removeClass('d-none');
                }
            });
    });
});

/**
 * initialize slick
 * @function initSlick
 */
function initSlick() {
    const isMobile = $(window).width() < 1024;
    const $slickContainer = $('.content-boxes');
    // Initialize Slick for mobile
    if (isMobile) {
        if (!$slickContainer.hasClass('slick-initialized')) {
            $slickContainer.slick({
                dots: true,
                arrows: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false
            });
        } else {
            // Resume autoplay in case it got paused after interaction/scroll
            $slickContainer.slick('slickPlay');
        }
    } else if ($slickContainer.hasClass('slick-initialized')) {
        $slickContainer.slick('unslick');
    }
}

$(document).ready(function () {
    // Initialize Slick on page load
    initSlick();

    // Recheck on window resize
    $(window).resize(function () {
        initSlick();
    });

    var isAuthenticated = $('.isLoggedInUser').length !== 0 && $('.isLoggedInUser').val() === 'true';

    if (!isAuthenticated) {
        $('#ckc-login-modal').modal('show');
        $('#ckc-login-modal').on('hidden.bs.modal', function () {
            var homeUrl = $('.logo-home').attr('href') || '/';
            window.location.href = homeUrl;
        });
    }
});

// Toggle someoneElseFields visibility when creatingForSomeoneElse checkbox is checked
$('body').on('change', '#creatingForSomeoneElse', function () {
    if ($(this).is(':checked')) {
        $('#someoneElseFields').removeClass('d-none');
    } else {
        $('#someoneElseFields').addClass('d-none');
        // Clear the relationship field when unchecking
        $('#registryRelationshipInput').val('');
        $('#registryRelationshipInput').closest('.custom-drop-down-section').find('.selected-value').text('Select Relationship');
    }
});

$('body').on('click', '.create-registry-box .create-btn', function (e) {
    e.preventDefault();
    var $target;
    if ($(window).width() >= 1024) {
        $target = $('#weddingRegistryForm');
    } else {
        $target = $('.mobile-create-registry');
    }

    var targetOffset = $target.offset().top;
    var targetHeight = $target.outerHeight();
    var windowHeight = $(window).height();

    var scrollPosition = targetOffset - (windowHeight / 2) + (targetHeight / 2);

    $('html, body').animate({
        scrollTop: scrollPosition
    }, 600);
});
